import { render } from "./CustomStepper.vue?vue&type=template&id=54197ac0"
import script from "./CustomStepper.vue?vue&type=script&lang=js"
export * from "./CustomStepper.vue?vue&type=script&lang=js"

import "./CustomStepper.vue?vue&type=style&index=0&id=54197ac0&lang=scss"
script.render = render

export default script